export default {"src":"/_next/static/media/ic-add-blue.015ad2d9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};